module.exports = __webpack_public_path__ + "static/media/what_do_banner.4f9892ce.png";